// extracted by mini-css-extract-plugin
module.exports = {"ecTemplateErrorLinks":"Error_ecTemplateErrorLinks__kewMi","showScale":"Error_showScale__yw_K4"};